// components/common/PageHeader.tsx
import React from 'react';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
    label: React.ReactNode; 
    path?: string;
    isActive?: boolean;
}


interface PageHeaderProps {
    title: string;
    breadcrumbs: BreadcrumbItem[];
    onExportCSV?: () => void;
    onExportExcel?: () => void;
    onExportPDF?: () => void;
    onAdd?: () => void;
    addLabel?: string;
    exportEnabled?: boolean;
    addButtonEnabled?: boolean;
    listViewPath?: string;
    rightExtra?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
    title,
    breadcrumbs,
    onExportCSV,
    onExportExcel,
    onAdd,
    addLabel = "Add",
    exportEnabled = false,
    addButtonEnabled = false,
    listViewPath,
    rightExtra
}) => {
    return (
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
                <h2 className="mb-1">{title}</h2>
                <nav>
                    <ol className="breadcrumb mb-0">
                        {breadcrumbs.map((item, index) => (
                            <li
                                key={index}
                                className={`breadcrumb-item ${item.isActive ? 'active' : ''}`}
                                aria-current={item.isActive ? 'page' : undefined}
                            >
                                {item.path ? <Link to={item.path}>{item.label}</Link> : item.label}
                            </li>
                        ))}
                    </ol>
                </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
               
                {exportEnabled && (
                    <div className="me-2 mb-2">
                        <div className="dropdown">
                            <Link
                                to="#"
                                className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                data-bs-toggle="dropdown"
                            >
                                <i className="ti ti-file-export me-1" />
                                Export
                            </Link>
                            <ul className="dropdown-menu dropdown-menu-end p-3">
                                {onExportCSV && (
                                    <li>
                                        <button
                                            onClick={onExportCSV}
                                            className="dropdown-item rounded-1"
                                        >
                                            <i className="ti ti-file-type-pdf me-1" />
                                            Export as CSV
                                        </button>
                                    </li>
                                )}
                                {onExportExcel && (
                                    <li>
                                        <button
                                            onClick={onExportExcel}
                                            className="dropdown-item rounded-1"
                                        >
                                            <i className="ti ti-file-type-xls me-1" />
                                            Export as Excel
                                        </button>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                )}
                {addButtonEnabled && (
                    <div className="mb-2">
                        <button
                            onClick={onAdd}
                            className="btn btn-primary d-flex align-items-center"
                        >
                            <i className="ti ti-circle-plus me-2" />
                            {addLabel}
                        </button>
                    </div>
                )}
                {rightExtra && <div className="ms-2 head-icons">{rightExtra}</div>}
            </div>
        </div>
    );
};

export default PageHeader;
